export default __webpack_public_path__ + "static/img2-0a5cf1d68ee4e07b423069a0af6584c5.jpg";